import CenterPage from './CenterPage';
import './CenterPage.css';

export default CenterPage;



// WEBPACK FOOTER //
// ./src/components/CenterPage/index.js